<div class="flex items-center justify-center py-[8%]">
        <div class="backdrop-blur-lg bg-red/18 border border-white border-red/18 rounded-3xl p-4 md:p-8 max-w-md w-full text-center shadow-2xl">
            <!-- Success Icon -->
             <i class="material-symbols-outlined text-emerald-500 !text-[50px] md:!text-[70px]">
                cancel
            </i>

            <!-- Success Message -->
            <div class="mb-8" >
                <h1 class="text-4xl md:text-5xl font-bold !text-white mb-4">
                    <!--i18n - Failure! -->
                    {{ 'i18n.app.features.pages.order.wizard.payment-result.failure.h1_01' | translate }} 
                </h1>
                <p class="text-xl text-white text-opacity-90 mb-2">
                    <!--i18n - Payment Aborted! -->
                    {{ 'i18n.app.features.pages.order.wizard.payment-result.failure.p_01' | translate }} 
                </p>
                <p class="text-white text-opacity-70">
                    <!--i18n - An error occured during the transaction -->
                    {{ 'i18n.app.features.pages.order.wizard.payment-result.failure.p_02' | translate }} 
                </p>
            </div>

            <!-- Footer Message -->
            <div class="mt-8 text-white text-opacity-60 text-sm" style="animation-delay: 0.8s;">
                <p>Please contact us!</p>
                <!-- <p>A confirmation email has been sent to your inbox.</p> -->
            </div>

            <!-- <div class="mt-8 text-white text-opacity-60 text-sm" style="animation-delay: 0.8s;">
                <p>--debug Stripe--</p>
                <p>id transaction: {{ _orderWizardService.orderWizard$()?.step06?.stripeId }}</p>
                <p>status: {{ _orderWizardService.orderWizard$()?.step06?.status }}</p>
                <h4>Finaliser l'ordre & envoyer le message à roger</h4>
            </div> -->
        </div>
    </div>